import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './global.css'

router.afterEach((to) => {
  const title = (to.meta?.title as string) || 'InforceIQ'
  const description = (to.meta?.description as string) || ''
  const robots = to.meta?.robots as string | undefined
  const canonicalUrl = new URL(to.path, 'https://www.inforceiq.com').toString()

  document.title = title
  setNamedMeta('description', description)
  setPropertyMeta('og:title', title)
  setPropertyMeta('og:description', description)
  setPropertyMeta('og:url', canonicalUrl)
  setNamedMeta('twitter:title', title)
  setNamedMeta('twitter:description', description)
  setNamedMeta('twitter:url', canonicalUrl)
  setNamedMeta('robots', robots)
  setLinkHref('link[rel="canonical"]', canonicalUrl)
})

function setNamedMeta(name: string, content?: string) {
  setMeta('name', name, content)
}

function setPropertyMeta(property: string, content?: string) {
  setMeta('property', property, content)
}

function setMeta(attribute: 'name' | 'property', key: string, content?: string) {
  let el = document.querySelector(`meta[${attribute}="${key}"]`)

  if (!content) {
    el?.remove()
    return
  }

  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attribute, key)
    document.head.appendChild(el)
  }

  el.setAttribute('content', content)
}

function setLinkHref(selector: string, href: string) {
  const el = document.querySelector(selector)
  if (el) el.setAttribute('href', href)
}

if (import.meta.env.PROD && import.meta.env.VITE_CLARITY_ID) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.textContent = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${import.meta.env.VITE_CLARITY_ID}");`
  document.head.appendChild(s)
}

const app = createApp(App)
app.use(router)
app.mount('#app')
